import type { JobFilter, JobRecord } from "../types/job.js";
import type { StorageAdapter } from "../types/storage.js";

export class PostgresStorageAdapter implements StorageAdapter {
  constructor() {
    throw new Error(
      "PostgresStorageAdapter is a design placeholder. Implement StorageAdapter using transactions, row-level locks, indexed status columns, and advisory locks for production use."
    );
  }

  saveJob(_job: JobRecord): Promise<void> {
    throw new Error("Not implemented");
  }
  updateJob(_jobId: string, _patch: Partial<JobRecord>): Promise<void> {
    throw new Error("Not implemented");
  }
  getJob(_jobId: string): Promise<JobRecord | null> {
    throw new Error("Not implemented");
  }
  listJobs(_filter?: JobFilter): Promise<JobRecord[]> {
    throw new Error("Not implemented");
  }
  deleteJob(_jobId: string): Promise<void> {
    throw new Error("Not implemented");
  }
  acquireLock(_lockKey: string, _ttlMs: number): Promise<boolean> {
    throw new Error("Not implemented");
  }
  releaseLock(_lockKey: string): Promise<void> {
    throw new Error("Not implemented");
  }
}
